<form [formGroup]="form" (ngSubmit)="onAction()">
  <app-modal-container>
    <span class="modal-header-content">
      {{ 'rule_action_modal_title_issue' + '_' + _action | translate }}
    </span>

    <div class="modal-body-content d-flex flex-column">
      <p class="body-content-heading">{{ 'rule_action_modal_description_issue' + '_' + _action | translate }}</p>

      <div class="d-flex flex-column align-items-start">
        <label for="reason" class="label margin-bottom-xs text-nowrap">
          {{ (reasonIsRequired ? 'label_reason_required' : 'label_reason_optional') | translate }}
        </label>

        <textarea
          id="reason"
          class="form-element w-100"
          rows="6"
          [formControlName]="'reason'"
          [attr.aria-describedby]="'reason-error'"
          #reasonTextarea
        ></textarea>

        <div id="reason-error">
          <app-form-field-error
            [formValidationRequest$]="formValidationRequest$"
            [field]="form.get('reason')"
            [name]="'reason'"
            label="reason"
            [errorMessageId]="'reason-error-message'"
          ></app-form-field-error>
        </div>
      </div>
    </div>

    <div class="modal-footer-content">
      <div class="d-flex justify-content-between">
        <button class="btn btn-outline-primary" type="button" (click)="close()">
          {{ 'label_close' | translate }}
        </button>
        <button class="btn btn-primary margin-left" type="submit" (click)="onAction()" data-e2e-id="issue-action-modal-submit">
          {{ 'rule_action_modal_action_issue' + '_' + _action | translate }}
        </button>
      </div>
    </div>
  </app-modal-container>
</form>
